<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useWorkspaceDisplayNames, useWorkspaceStore } from '#layers/workspace/public';

const { currentWorkspace } = storeToRefs(useWorkspaceStore());
const { getWorkspaceDisplayName } = useWorkspaceDisplayNames();
</script>

<template>
	<span class="truncate text-sm font-semibold">{{ getWorkspaceDisplayName(currentWorkspace) }}</span>
</template>
